import React, { useEffect, useState } from "react";
import MainScreen from "../../components/Navbar/MainScreen";
import CustomInput from "../../components/CustomInput/CustomInput";
import { Box, Card, Typography } from "@mui/material";
import "../Dashboard.css";
import { FaArrowLeftLong } from "react-icons/fa6";
import { IconContext } from "react-icons";
import CustomDropdown from "../../components/CustomDropDown/CustomDropDown";
import { priorityStatus } from "../../utils/Constants";
import { connect } from "react-redux";
import Select from "react-select";

function NotificationCenter(props) {
  const [employeeList, setEmployeeList] = useState([]);
  useEffect(() => {
    console.log("sadnasdasdsa", props.employee_data);

    if (props.employee_data.length > 0) {
      setEmployeeList(props.employee_data);
    }
  }, [props.employee_data]);
  return (
    <MainScreen>
      <Box className="dashboard-main-container">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingTop: 3,
            paddingBottom: 1,
            paddingLeft: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                mr: 1,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => {
                //   navigate(-1);
              }}
            >
              <IconContext.Provider value={{ size: 25, color: "#000" }}>
                <FaArrowLeftLong />
              </IconContext.Provider>
            </Box>
            {/* <h9 className="header-text">Contact Capture</h9> */}
            <Typography
              style={{
                fontSize: 22,
                fontWeight: 600,
                color: "#000",
                marginRight: 10,
                textAlign: "start",
              }}
            >
              Notification Center
            </Typography>
          </Box>
        </Box>
        <Card
          sx={{
            ml: 1,
            mr: 1,
            p: 1,
          }}
        >
          <Typography
            style={{
              fontSize: 18,
              fontWeight: 600,
              color: "#000",
              marginBottom: 10,
              textAlign: "start",
            }}
          >
            Create Notification
          </Typography>
          <Box className="as-inner-container">
            <div className="fields-width">
              <span>Notification Priority</span>
              <Select
                options={priorityStatus}
                placeholder={"Select Notification Priority"}
                onChange={(e) => {}}
                menuPortalTarget={document.body}
                // icon={Icons.campaign}
                // Value={createCampaignData.NOTIFICATION_NAME}
                // onChange={(e) => {
                //   setCreateCampaignData((prev) => ({
                //     ...prev,
                //     CAMPAIGN_NAME: e.target.value,
                //     CAMPAIGN_NAME_ERROR: false,
                //   }));
                // }}
              />
              {/* {createCampaignData.CAMPAIGN_NAME_ERROR && (
        <p className="helper-text">Please enter Campaign Description</p>
      )} */}
            </div>
            <div className="fields-width">
              <span>Recipients</span>
              <Select
                options={employeeList}
                isMulti
                // menuPortalTarget={true}
                menuPortalTarget={document.body}
                placeholder={"Select Recipients"}
                onChange={(e) => {}}
                // icon={Icons.campaign}
                // Value={createCampaignData.NOTIFICATION_NAME}
                // onChange={(e) => {
                //   setCreateCampaignData((prev) => ({
                //     ...prev,
                //     CAMPAIGN_NAME: e.target.value,
                //     CAMPAIGN_NAME_ERROR: false,
                //   }));
                // }}
              />
              {/* {createCampaignData.CAMPAIGN_NAME_ERROR && (
        <p className="helper-text">Please enter Campaign Description</p>
      )} */}
            </div>
            <div className="fields-width">
              <span>Notification Title</span>
              <div className="group">
                <textarea
                  rows={1}
                  className="text-box-style"
                  style={{
                    height: 40,
                    fontFamily: "sans-serif",
                  }}
                  placeholder={"Notification Content"}
                  // icon={Icons.campaign}
                  // value={createCampaignData.NAME}
                  // onChange={(e) => {
                  //   setCreateCampaignData((prev) => ({
                  //     ...prev,
                  //     CAMPAIGN_DESCRIPTION: e.target.value,
                  //     CAMPAIGN_DESCRIPTION_ERROR: false,
                  //   }));
                  // }}
                />
              </div>
              {/* {createCampaignData.CAMPAIGN_NAME_ERROR && (
        <p className="helper-text">Please enter Campaign Description</p>
      )} */}
            </div>
            <div className="fields-width">
              <span>Notification Content</span>
              <div className="group">
                <textarea
                  rows={1}
                  className="text-box-style"
                  style={{
                    height: 40,
                    fontFamily: "sans-serif",
                  }}
                  placeholder={"Notification Content"}
                  // icon={Icons.campaign}
                  // value={createCampaignData.NAME}
                  // onChange={(e) => {
                  //   setCreateCampaignData((prev) => ({
                  //     ...prev,
                  //     CAMPAIGN_DESCRIPTION: e.target.value,
                  //     CAMPAIGN_DESCRIPTION_ERROR: false,
                  //   }));
                  // }}
                />
              </div>
              {/* {createCampaignData.CAMPAIGN_NAME_ERROR && (
        <p className="helper-text">Please enter Campaign Description</p>
      )} */}
            </div>

            <div className="fields-width">
              <button
                className="signup-button"
                style={{
                  // marginRight: 10,
                  minWidth: 150,
                  minHeight: 38,
                  // maxHeight: 30,
                  marginTop: 24,
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  backgroundColor: "#23a466",
                }}
                // onClick={excelDownload}
              >
                Send Notification
                {/* {exportLoading ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    <>
                      <img src={ExcelIcon} style={{ width: 25, height: 25 }} />
                      <span className="sp">Export</span>
                    </>
                  )} */}
              </button>
            </div>
          </Box>
        </Card>
      </Box>
    </MainScreen>
  );
}
const mapStateToProps = (state) => ({
  employee_data: state.contactData.employeeList,
  auth_id: state.contactData.auth_id,
  role: state.contactData.role,
  components_list: state.contactData.components_list,
});

export default connect(mapStateToProps)(NotificationCenter);
